const domain = window.location.hostname;
// let API_URL = process.env.ADMIN_API_URL ?? "https://api.staging.vseli.com/admin/api";
// let API_URL = process.env.ADMIN_API_URL ?? "http://localhost/admin/api";
let API_URL = process.env.ADMIN_API_URL ?? "http://erp-api.test/admin/api";

if (domain !== "localhost") {
    API_URL = `https://api.${domain}/admin/api`;
}

if (domain == "simulation.akta.american-systems.pl") {
    API_URL = "https://api.akta.american-systems.pl/admin/api";
}

// if (domain == "localhost") {
//     API_URL = "https://api.esmetric.app.erpspace.pl/admin/api";
// }


export {
    API_URL
};

async function client(endpoint, { data, method, headers: customHeaders, ...customConfig } = {}) {
    const token = window.localStorage.getItem("auth.token");
    const config = {
        method: method ? method : (data ? "POST" : "GET"),
        body: data ? JSON.stringify(data) : undefined,
        headers: {
            "Accept": "application/json",
            "Authorization": token ? `Bearer ${JSON.parse(token)}` : undefined,
            "Content-Type": data ? "application/json" : undefined,
            ...customHeaders,
        },
        ...customConfig,
    };

    return window.fetch(`${API_URL}/${endpoint}`, config)
        .then(async response => {
            let data;
            try {
                data = await response.json();
            } catch {
                data = null;
            }

            if (response.status === 401) {
                window.localStorage.removeItem("auth.token");
                window.location.href = "/login?redirect=" + window.location.pathname;
                return Promise.reject(data);
            }

            if (response.ok) {
                return data;
            } else {
                return Promise.reject(data);
            }
        })
        .catch(e => {
            return Promise.reject(e || { message: "Unexpected error" });
        });
}

export default client;